import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_cody.png",
      alt: "Estratégias Cody",
    },
    title: "Conheça Cody, o robô da bolsa impulsionado por IA.",

    // String ou array de strings
    text: "Cody está pronto para ajudá-lo a alcançar seus objetivos financeiros.",
    testimonial: {
      text: [
        "Caro investidor,",
        "Queremos expressar nossa gratidão por confiar em nós como parceiros em sua jornada financeira. Sabemos que tomar decisões de investimento é uma tarefa desafiadora, mas estamos aqui para fornecer suporte e orientação em cada passo do caminho.",
        "Nosso compromisso é usar a inteligência artificial para ajudá-lo a tomar decisões informadas e maximizar seu potencial de ganhos. Nossos robôs de investimento são projetados para analisar dados em tempo real, identificar tendências e oportunidades promissoras, tudo com o objetivo de alcançar resultados consistentes e sólidos",
        "Lembre-se de que investir envolve riscos e volatilidade faz parte do jogo. No entanto, estamos aqui para ajudá-lo a navegar pelas incertezas do mercado e tomar decisões embasadas. A transparência e a confiança são valores fundamentais para nós, e faremos tudo o que estiver ao nosso alcance para manter essa relação sólida com você.",
        "Obrigado por fazer parte da nossa jornada. Estamos comprometidos em fornecer a você as melhores soluções de investimento com a ajuda da inteligência artificial.",
      ],
      author: {
        name: "Mauro Moura - Estrategista Quantic trading/Cody",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias Cody",
    heading:
      "Cody, equipado com algoritmos de última geração e inteligência artificial avançada, é o seu aliado para conquistar resultados extraordinários.",
    // subtitle:
    //   "O algoritmo Veedha WIN atua com mini-índice e o Veedha WDO com mini-dólar futuro, usando análises quantitativas para ganhos acima da média, com segurança e controle de risco. Recomendamos usar ambas as estratégias para melhores resultados no longo prazo.",
  },

  cta: {
    title: "Tudo pronto?",
    subtitle: "Ative agora mesmo a extensão.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "O Cody",
    col1: [
      "Somos uma equipe apaixonada por tecnologia e finanças, dedicada a desenvolver robôs de investimento inovadores, impulsionados pela inteligência artificial.",
      "Aqui, combinamos o melhor dos dois mundos: a expertise em investimentos e a capacidade da inteligência artificial de analisar dados e identificar oportunidades no mercado financeiro. ",
      "Nossos robôs são programados para tomar decisões informadas, levando em consideração indicadores-chave, tendências e análises de risco. Estamos comprometidos em fornecer soluções de investimento acessíveis, confiáveis e eficientes para nossos clientes.",
    ],
    col2: [
      "Com nosso robô de investimento, você pode operar na bolsa 100% automatizado, maximizando seu potencial de ganhos e reduzindo o estresse associado à tomada de decisões. ",
      "Siga nossas redes sociais para ficar atualizado sobre as últimas tendências no mercado financeiro, dicas de investimento e casos de sucesso de nossos clientes. Estamos aqui para ajudá-lo a alcançar seus objetivos financeiros com a ajuda da inteligência artificial! 💰🚀",
    ],
  },

  // stats: {
  //   title: "Alguns números da Veedha",
  //   subtitle:
  //     "Décadas de expertise com números que provam o nosso conhecimento de mercado.",
  //   data: [
  //     {
  //       value: "+8 bi",
  //       description: "Sob custódia",
  //     },
  //     {
  //       value: "+15k",
  //       description: "Clientes",
  //     },
  //     {
  //       value: "Top 10",
  //       description: "Escritórios da XP",
  //     },
  //   ],
  // },

  features: {
    title:
      "Explore as incríveis vantagens de utilizar a inteligência artificial nos investimentos automatizados!",
    subtitle:
      "Com a combinação perfeita entre tecnologia avançada e análise inteligente, você desfrutará de:",
    data: [
      {
        icon: iconsSet.balance,
        title: "Tomada de decisão imparcial",
        description:
          "A inteligência artificial não é influenciada por emoções ou preconceitos, o que elimina qualquer viés humano nas decisões de investimento. Isso garante uma abordagem objetiva, baseada apenas em análises e dados concretos.",
      },
      {
        icon: iconsSet.analytics,
        title: "Análise abrangente",
        description:
          "A IA é capaz de analisar uma ampla gama de indicadores, tendências e padrões complexos que seriam praticamente impossíveis para um investidor individual acompanhar. Isso permite identificar oportunidades ocultas e potenciais riscos com maior eficiência.",
      },
      {
        icon: iconsSet.click,
        title: "Precisão aprimorada",
        description:
          "A inteligência artificial utiliza algoritmos sofisticados para analisar uma quantidade enorme de dados em tempo real, resultando em decisões de investimento mais precisas e fundamentadas.",
      },
      {
        icon: iconsSet.tune,
        title: "Aprendizado contínuo",
        description:
          "A inteligência artificial aprende constantemente com dados históricos e experiências anteriores, adaptando-se e melhorando suas estratégias ao longo do tempo. Isso significa que seus investimentos automatizados se tornam cada vez mais refinados e otimizados.",
      },
      // {
      //   icon: iconsSet.analytics,
      //   title: "Estratégia com histórico",
      //   description:
      //     "A Veedha já opera diariamente mais de 10 mil minicontratos, o que mostra que o nosso algoritmo já é baseado em um alto volume de negociação",
      // },
      // {
      //   icon: iconsSet.ads_click,
      //   title: "Simples de usar",
      //   description:
      //     "Ativando a extensão basta um toque para ativar a sua estratégia",
      // },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
